import { memo } from 'react'
import Heading from '../../../../LuxKit/Typography/Heading'
import { INTL_LONG_MONTH_LONG_YEAR, INTL_SHORT_MONTH_LONG_YEAR } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'

interface Props {
  longMonthNames?: boolean
  currentDate: Date
}

function VerticalDatePickerHeader(props: Props) {
  const {
    currentDate,
    longMonthNames,
  } = props

  const formatDate = useIntlDateFormatter()
  const monthLabel = formatDate(currentDate, longMonthNames ? INTL_LONG_MONTH_LONG_YEAR : INTL_SHORT_MONTH_LONG_YEAR)

  return (
    <Heading variant="heading5">{monthLabel}</Heading>
  )
}

export default memo(VerticalDatePickerHeader)
